export default __webpack_public_path__ + "static/media/notifications.3713947c.svg";